export default "__VITE_ASSET__Bq$vcuYy__"